exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sort-dropdown__option{width:100%;display:block}.sort-dropdown__option:not(:last-child){margin-bottom:.5rem}.sort-dropdown__option input{margin-right:.5rem}", ""]);

// exports
